/* =========================================================
   Dolls In Love — Menü, Warenkorb (Shopify), Kleinkram (alle Unterseiten)
   Der Warenkorb ist der echte Shopify-Warenkorb (/cart.js).
   Ausstattungsoptionen liegen als eigene Zeilen im Warenkorb und hängen
   über die Eigenschaft _gruppe an ihrer Puppe: Menge ändern oder entfernen
   wirkt auf die ganze Gruppe.
   ========================================================= */
(function () {
  'use strict';
  const $  = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* --- Menü --- */
  const burger = $('#burger'), nav = $('#nav');
  if (burger && nav) {
    burger.addEventListener('click', () => nav.classList.toggle('is-open'));
    $$('#nav a').forEach(a => a.addEventListener('click', () => nav.classList.remove('is-open')));
  }

  const euro = c => (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let stand = { items: [], item_count: 0, total_price: 0 };

  async function api(pfad, daten) {
    const r = await fetch(root + pfad, daten ? {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(daten)
    } : { headers: { Accept: 'application/json' } });
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || j.message || 'Warenkorb nicht erreichbar');
    return j;
  }
  async function lade() { stand = await api('cart.js'); paint(); return stand; }

  /* Puppen-Zeile mit ihren Optionen zusammenfassen */
  function gruppen() {
    const g = [], nach = {};
    const prop = (it, k) => it.properties && it.properties[k];
    // erst die Puppen (Shopify liefert die zuletzt hinzugefügte Zeile zuerst) …
    stand.items.forEach(it => {
      if (prop(it, '_option')) return;
      const e = { haupt: it, optionen: [] };
      if (prop(it, '_gruppe')) nach[prop(it, '_gruppe')] = e;
      g.push(e);
    });
    // … dann die Optionen an ihre Puppe hängen; verwaiste Optionen einzeln zeigen
    stand.items.forEach(it => {
      if (!prop(it, '_option')) return;
      const e = nach[prop(it, '_gruppe')];
      if (e) e.optionen.push(it); else g.push({ haupt: it, optionen: [] });
    });
    return g;
  }

  window.DIL_CART = {
    async addItems(items) {
      await api('cart/add.js', { items });
      await lade();
      open();
    },
    count() { return stand.item_count; }
  };

  function paint() {
    const puppen = stand.items.filter(i => i.properties && i.properties._typ === 'puppe').reduce((s, i) => s + i.quantity, 0);
    const sichtbar = stand.items.filter(i => !(i.properties && i.properties._option)).reduce((s, i) => s + i.quantity, 0);
    const badge = $('#cartCount');
    if (badge) { badge.textContent = sichtbar; badge.classList.toggle('is-full', sichtbar > 0); }
    const body = $('#cartBody');
    if (!body) return;
    const G = gruppen();
    body.innerHTML = G.length ? G.map((e, i) => {
      const it = e.haupt;
      const aufpreis = e.optionen.reduce((s, o) => s + o.final_price, 0);
      const ausst = (it.properties && it.properties.Ausstattung) || (e.optionen.length ? '' : (it.variant_title || ''));
      const bild = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      return `
      <div class="citem">
        ${bild ? `<img src="${esc(bild)}" alt="">` : '<span></span>'}
        <div class="citem__txt">
          <strong>${esc(it.product_title)}</strong>
          <span>${esc(ausst)}</span>
          <span class="citem__price">${euro(it.final_price + aufpreis)}</span>
        </div>
        <div class="citem__qty">
          <button data-act="minus" data-i="${i}" aria-label="weniger">−</button>
          <span>${it.quantity}</span>
          <button data-act="plus" data-i="${i}" aria-label="mehr">+</button>
        </div>
        <button class="citem__del" data-act="del" data-i="${i}" aria-label="entfernen">&times;</button>
      </div>`;
    }).join('') : '<p class="cart__empty">Noch nichts ausgewählt.</p>';
    if ($('#cartSum')) $('#cartSum').textContent = euro(stand.total_price);
    const note = $('.cart__note');
    if (note) note.textContent = stand.items.length
      ? `Inkl. MwSt. · zzgl. Versand${puppen ? ` (Spedition ${puppen} × 499,00 €)` : ''}, wird an der Kasse berechnet`
      : 'Inkl. MwSt. · zzgl. Versand';
    if ($('#cartCheckout')) $('#cartCheckout').disabled = !stand.items.length;
  }

  const cart = $('#cart');
  function open()  { if (!cart) return; cart.hidden = false; setTimeout(() => cart.classList.add('is-in'), 10); }
  function close() { if (!cart) return; cart.classList.remove('is-in'); setTimeout(() => { cart.hidden = true; }, 350); }
  if ($('#cartBtn')) $('#cartBtn').addEventListener('click', open);
  if ($('#cartClose')) $('#cartClose').addEventListener('click', close);
  if (cart) cart.addEventListener('click', e => { if (e.target === cart) close(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

  if ($('#cartBody')) $('#cartBody').addEventListener('click', async e => {
    const b = e.target.closest('button[data-act]'); if (!b) return;
    const g = gruppen()[+b.dataset.i]; if (!g) return;
    const q = g.haupt.quantity;
    const neu = b.dataset.act === 'plus' ? q + 1 : b.dataset.act === 'minus' ? Math.max(1, q - 1) : 0;
    const updates = {};
    [g.haupt].concat(g.optionen).forEach(it => { updates[it.key] = neu; });
    b.disabled = true;
    try { await api('cart/update.js', { updates }); } catch (err) {}
    lade();
  });
  if ($('#cartCheckout')) $('#cartCheckout').addEventListener('click', function () {
    this.disabled = true;
    location.href = root + 'checkout';
  });
  lade().catch(() => {});

  /* --- Herstellerseite: Anzahl der Modelle einsetzen --- */
  $$('[data-count]').forEach(el => {
    const h = el.dataset.count;
    const n = (window.DOLLS || []).filter(d => d.hersteller === h).length;
    if (n) el.textContent = n + ' Modelle in der Galerie';
  });

  /* --- Showroom: ruhiger Kalender, sichtbar aber inaktiv --- */
  const cal = $('#bookingCal');
  if (cal) {
    const namen = ['Mo','Di','Mi','Do','Fr','Sa','So'];
    let html = '<div class="cal__head"><span>Januar 2027</span></div><div class="cal__grid">';
    namen.forEach(n => html += `<span class="cal__wd">${n}</span>`);
    for (let i = 0; i < 4; i++) html += '<span></span>';
    for (let d = 1; d <= 31; d++) {
      const frei = [8,9,15,16,22,23].includes(d);
      html += `<span class="cal__day${frei ? ' is-free' : ''}">${d}</span>`;
    }
    cal.innerHTML = html + '</div>';
  }
})();
